import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { VirtualScrollerModule } from '@akhan94/ngx-virtual-scroller';
import { TranslateModule } from '@ngx-translate/core';

import { MgButtonModule } from '@app/src/app/button';
import { AvatarClusterModule } from '@app/src/app/components/AvatarCluster';
import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgDirectivesModule } from '@app/src/app/directives';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgPersonListElementModule } from '@app/src/app/elements/MgPersonListElement';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { MgIconModule } from '@app/src/app/icon';
import { SearchModule } from '@app/src/app/search';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { LayoutLegacyContentModule } from '@modules/layout/components/layout-legacy-content/layout-legacy-content.module';

import { GenericModule } from '@shared/components/generic';
import { PortalLayoutModule } from '@shared/components/portal-layout';

import { DmListFeedComponent } from './components/dm-list-feed/dm-list-feed.component';
import { DmListItemComponent } from './components/dm-list-item/dm-list-item.component';
import { DmListComponent } from './dm-list.component';

@NgModule({
  imports: [
    // Minga dependencies
    VirtualScrollerModule,
    SearchModule,
    MgDirectivesModule,
    MgPersonListElementModule,
    MgSpinnerModule,
    MgButtonModule,
    MgIconModule,
    MgEmptyStateModule,
    MgAvatarModule,
    AvatarClusterModule,
    MgPersonMinimalModule,
    LayoutLegacyContentModule,
    GenericModule,
    PortalLayoutModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    TranslateModule,
  ],
  declarations: [DmListComponent, DmListFeedComponent, DmListItemComponent],
  exports: [DmListItemComponent],
})
export class DirectMessageListModule {}
